import { isVideoStation, isYoutubeNativeStation } from '@app/core/stations/helpers';
import { StationTypeFilterType } from '../components/options';
import { Station } from '@app/core/types/stations';

/** Maps a station to the status screen station-type filter bucket (radio, TV, or YouTube Native). */
export function getStationTypeFilterType(station: Station): StationTypeFilterType {
  if (isYoutubeNativeStation(station)) {
    return StationTypeFilterType.YOUTUBE;
  }

  if (isVideoStation(station)) {
    return StationTypeFilterType.TV;
  }

  return StationTypeFilterType.RADIO;
}
